module.exports = __webpack_public_path__ + "static/media/premium-case.65b5f014.jpg";